core.factory('oa2AuthInterceptor', [ '$q', '$rootScope', 'config',
    function ($q, $rootScope, appConfig) {

        var self = this;

        this.token = null;

        $rootScope.$on(Event.USER.LOGIN.SUCCESS, function (event, token) {
            self.token = token;
        });

        $rootScope.$on(Event.USER.LOGOUT.SUCCESS, function (event) {
            self.token = null;
        });

        return {
            request: function(config) {
                if (config && config.method && config.method == 'POST' && config.url && (config.url.indexOf(appConfig.API_URL) > -1)) {
                    if (self.token) {
                        config.headers['Authorization'] = 'Bearer ' + self.token;
                    }
                }
                return config;
            }
        };
    }
]);
